<template>
  <div class="base wafe">
    <inside-header title="提现" color="#f6f6f6" />
    <div class="case">
      <div class="withdrawal-panel">
        <div class="node">
          <span class="icon">
            <van-icon name="alipay" color="#1677ff" size="16" />
          </span>
          <span class="pay">提现到支付宝</span>
        </div>
        <div class="input">
          <a-input placeholder="请输入支付宝账号" />
        </div>
      </div>
    </div>
    <div class="cake">
      <div class="dome">
        提现金额
      </div>
      <div class="money">
        <span class="only">￥</span>
        <span class="only-one">99.00</span>
      </div>
      <hr style="margin-top:10px;border:1px solid #f6f6f6">
      <div class="mody">
        <span class="moment">当前可提现金额125.00元,</span>
        <span class="all">全部提现</span>
      </div>
      <div class="btn-area">
        <a-button block type="primary">
          立即提现
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'WithdrawDeposit',
  components: {
    InsideHeader
  }
}
</script>
<style lang="stylus" scoped>
    .wafe {
        min-width:280px;max-width:420px;background-color:#fff;
        .case {
            padding:15px;background-color:#f6f6f6;
            .withdrawal-panel {
                padding: 15px;height: 110px;background-color: #ffffff;border-radius: 10px;
                .node {
                    overflow:hidden;line-height: 15px;
                    .icon {
                        position: relative;top: 3px;
                    }
                    .pay {
                        font-size: 14px;line-height: 14px;color: #333333;margin-left: 5px;
                    }
                }
                .input {
                    margin-top: 16px;
                }
            }
        }
        .cake {
            padding:30px;background-color:#fff;border-radius:25px;
            .dome {
                font-size:14px;color:#333333;
            }
            .money {
                margin-top:15px;padding-top:15px;padding-bottom:15px;
                .only {
                    font-size:18px;line-height:19px;color:#333333;
                }
                .only-one {
                    margin-left:13px;font-size:36px;color:#333333;line-height:14px;
                }
            }
            .mody {
                margin-top:15px;
                .moment {
                    font-size:12px;line-height:19px;color:#666666;
                }
                .all {
                    font-size:12px;color:#ff5c00;
                }
            }
            .btn-area {
                height:40px;border-radius:10px;margin-top:60px;
            }
        }
    }
</style>
